export default "__VITE_ASSET__DltET5N8__"